import React, {Fragment} from "react";

export const TextArea = ({state, setState, rows = 7, removeHandler = null, setterArgs}) => (
    <Fragment>
        <textarea
            value={state}
            className='pl-3 pt-1 pb-1'
            rows={rows}
            onChange={e => {
                setState(e.target.value, setterArgs)
            }}
        />
        {removeHandler?(
            <button type="button" onClick={() => removeHandler(setterArgs)} className="close textarea_close" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        ):''}

    </Fragment>
)